var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgA6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.86 27.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-A6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.47,28H22.69c1.75,0,2.37-.8,2.42-2.43V10.35A2.54,2.54,0,0,0,23.8,8.21c-1.13-.61-3.77-.14-5-.29-.31,0-.72-.55-.92-.79A12.11,12.11,0,0,0,16.1,5.41h-7c-.46,0-.91.73-1.13,1s-.33.31-.51.51c-1.06,1.27-.84,1-2.2,1H3.1C1.6,7.91.79,8.3.28,9.33c-.41.83-.24,3-.24,4.07S-.06,25.36.1,26A2.53,2.53,0,0,0,2.47,28Zm9.61-16.26a6.26,6.26,0,1,0,6.73,5.72,6.24,6.24,0,0,0-6.73-5.72Z",
    transform: "translate(-0.01 0)",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.81,14a4,4,0,1,0,4.71,3.13A4,4,0,0,0,11.81,14Z",
    transform: "translate(-0.01 0)",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.27 0 26.36 0 26.36 3.59 22.77 3.59 22.77 4.5 26.36 4.5 26.36 8.09 27.27 8.09 27.27 4.5 30.86 4.5 30.86 3.59 27.27 3.59 27.27 0",
    fill: "gray"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA6);
export default __webpack_public_path__ + "static/media/A6.8d7fdc9bafae692dd3e740e33df6b27e.svg";
export { ForwardRef as ReactComponent };